import React, { useEffect, useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { getAccountLoginUrl } from "../utils/accountApp";

interface PrivateRouteProps {
	children: React.ReactNode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
	const { isAuthenticated, checkAuth } = useAuth();
	const [isChecking, setIsChecking] = useState(true);

	useEffect(() => {
		const verifyAuth = async () => {
			await checkAuth();
			setIsChecking(false);
		};
		verifyAuth();
	}, [checkAuth]);

	useEffect(() => {
		if (!isChecking && !isAuthenticated) {
			const currentUrl = window.location.href;
			const loginUrl = getAccountLoginUrl();

			// Save the attempted URL for redirecting after login
			window.location.href = `${loginUrl}?redirect=${encodeURIComponent(
				currentUrl
			)}`;
		}
	}, [isChecking, isAuthenticated]);

	if (isChecking) {
		return null; // Or a loading spinner
	}

	if (!isAuthenticated) {
		return null;
	}

	return <>{children}</>;
};

export default PrivateRoute;
